// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./grid-lines-container\"></require>\n  <grid-lines-container mooring-id.bind=\"data.mooringId\" review-id.bind=\"data.activeReviewId\"></grid-lines-container>\n</template>\n";
// Exports
export default code;